import React from 'react';
import {
  HiddenCheckboxInput,
  StyledCircle,
  StyledSlider,
  StyledSwitchLabel,
  SwitchLabel,
} from './styled';

export interface SwitchProps {
  name?: string;
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  value?: boolean;
}
export const Switch: React.FC<SwitchProps> = ({
  name,
  disabled,
  value = false,
  onChange,
  ...props
}) => {
  const handleOnChange = () => {
    onChange && onChange(!value);
  };

  return (
    <StyledSwitchLabel checked={value} disabled={disabled}>
      {name && <SwitchLabel>{name}</SwitchLabel>}
      <HiddenCheckboxInput
        checked={value}
        disabled={disabled}
        onChange={handleOnChange}
      />
      <StyledSlider checked={value} disabled={disabled}>
        <StyledCircle checked={value} disabled={disabled} />
      </StyledSlider>
    </StyledSwitchLabel>
  );
};
